import React from 'react';
import { Check } from 'lucide-react';

import { cn } from '../../lib/utils';

/**
 * Les quatre temps du poste (programme Stations, lot 030) : chaque écran dit à
 * quelle étape de la journée il appartient et propose la suivante.
 *
 *  - `current` : 1 Ouverture, 2 Pendant le poste, 3 Clôture, 4 Arrêt de la journée ;
 *  - `onSelect(step)` : facultatif, rend cliquables les étapes déjà atteintes.
 */
export const SHIFT_STEPS = ['Ouverture', 'Pendant le poste', 'Clôture', 'Arrêt de la journée'];

export const ShiftSteps = ({ current = 1, onSelect, className }) => (
  <ol className={cn('flex flex-wrap items-center gap-1.5 text-sm', className)} aria-label="Étapes du poste">
    {SHIFT_STEPS.map((titre, position) => {
      const numero = position + 1;
      const fait = numero < current;
      const maintenant = numero === current;
      const cliquable = Boolean(onSelect) && numero <= current;
      const contenu = (
        <>
          <span
            className={cn(
              'inline-flex h-5 w-5 items-center justify-center rounded-full text-xs font-semibold',
              fait && 'bg-success text-white',
              maintenant && 'bg-flame text-white',
              !fait && !maintenant && 'bg-muted text-muted-foreground',
            )}
            aria-hidden="true"
          >
            {fait ? <Check className="h-3 w-3" /> : numero}
          </span>
          {titre}
        </>
      );
      return (
        <li key={titre} aria-current={maintenant ? 'step' : undefined} className="flex items-center gap-1.5">
          {cliquable ? (
            <button
              type="button"
              onClick={() => onSelect(numero)}
              className={cn(
                'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1',
                maintenant ? 'border-flame/40 bg-flame/10 font-semibold' : 'border-border bg-card hover:bg-muted',
              )}
            >
              {contenu}
            </button>
          ) : (
            <span
              className={cn(
                'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1',
                maintenant ? 'border-flame/40 bg-flame/10 font-semibold' : 'border-border bg-card text-muted-foreground',
              )}
            >
              {contenu}
            </span>
          )}
          {numero < SHIFT_STEPS.length && <span className="hidden h-px w-4 bg-border sm:block" aria-hidden="true" />}
        </li>
      );
    })}
  </ol>
);

export default ShiftSteps;
